import React from 'react'
import css from './style.css'

const DetailsItem = (props) => {
  let value = props.formatter ? props.formatter(props.value) : props.value
  return (
    <div className={css.detailsItem}>
      <div className={css.title}>{props.title}</div>
      <div>{props.href ? <a href={props.href} target='_blank' rel='noreferrer'>{value}</a> : value}</div>
    </div>
  )
}

export default DetailsItem



// WEBPACK FOOTER //
// ./src/components/details-item/index.js